import { getAdminUrl, getMergedHeaders, useReapitConnectSession } from '@reapitform/hooks'
import { AdminFormVersionResponse } from '../types'

/**
 * Imperative copy-version helper. The version being copied is only known at click time (per row in the
 * dashboard grid), so this can't use the fixed-path `useAdminUpdate` hook. Clones the version's entire
 * subgraph into a brand new sibling version (`POST /api/forms/{formRef}/versions/{versionRef}/copy`).
 */
export const useCopyFormVersion = () => {
  const session = useReapitConnectSession()

  return async (formReferenceID: string, versionReferenceID: string): Promise<AdminFormVersionResponse> => {
    const headers = await getMergedHeaders(session)
    if (!headers) throw new Error('Your session has expired — please sign in again.')

    const path = `/api/forms/${formReferenceID}/versions/${versionReferenceID}/copy`
    const response = await fetch(getAdminUrl(path)(), {
      method: 'POST',
      headers: headers as HeadersInit,
    })

    if (!response.ok) {
      let message = `Copy failed (${response.status})`
      try {
        const body = await response.json()
        message = body?.description || body?.Description || message
      } catch {
        // Non-JSON body — keep the status-based message.
      }
      throw new Error(message)
    }

    return (await response.json()) as AdminFormVersionResponse
  }
}
